var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 24,
    viewBox: "0 0 43 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2221_645)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 34.4,
    height: 16,
    rx: 3,
    fill: "#99D529"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 3.5,
    width: 33.4,
    height: 15,
    rx: 2.5,
    stroke: "#99D529"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.776 13.9914C13.016 13.9914 13.2176 13.9626 13.3808 13.905C13.544 13.8474 13.6736 13.7706 13.7696 13.6746C13.8688 13.5786 13.9392 13.4666 13.9808 13.3386C14.0256 13.2106 14.048 13.0746 14.048 12.9306C14.048 12.7802 14.024 12.6458 13.976 12.5274C13.928 12.4058 13.8528 12.3034 13.7504 12.2202C13.648 12.1338 13.5152 12.0682 13.352 12.0234C13.192 11.9786 12.9984 11.9562 12.7712 11.9562H11.4704V13.9914H12.776ZM11.4704 9.05699V11.0634H12.4976C12.9392 11.0634 13.272 10.9834 13.496 10.8234C13.7232 10.6634 13.8368 10.409 13.8368 10.0602C13.8368 9.69859 13.7344 9.44099 13.5296 9.28739C13.3248 9.13379 13.0048 9.05699 12.5696 9.05699H11.4704ZM12.5696 8.05859C13.024 8.05859 13.4128 8.10179 13.736 8.18819C14.0592 8.27459 14.3232 8.39779 14.528 8.55779C14.736 8.71779 14.888 8.91139 14.984 9.13859C15.08 9.36579 15.128 9.62179 15.128 9.90659C15.128 10.0698 15.104 10.2266 15.056 10.377C15.008 10.5242 14.9328 10.6634 14.8304 10.7946C14.7312 10.9226 14.6032 11.0394 14.4464 11.145C14.2928 11.2506 14.1088 11.3402 13.8944 11.4138C14.848 11.6282 15.3248 12.1434 15.3248 12.9594C15.3248 13.2538 15.2688 13.5258 15.1568 13.7754C15.0448 14.025 14.8816 14.241 14.6672 14.4234C14.4528 14.6026 14.1888 14.7434 13.8752 14.8458C13.5616 14.9482 13.2032 14.9994 12.8 14.9994H10.1792V8.05859H12.5696Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7939 9.08579V11.0106H20.2227V12.0042H17.7939V13.9674H20.8755V14.9994H16.4979V8.05859H20.8755V9.08579H17.7939Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8678 9.11939H24.775V14.9994H23.4838V9.11939H21.391V8.05859H26.8678V9.11939Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7683 12.3786L29.9235 10.0698C29.8819 9.96739 29.8387 9.84579 29.7939 9.70499C29.7491 9.56419 29.7043 9.41219 29.6595 9.24899C29.6179 9.41219 29.5747 9.56579 29.5299 9.70979C29.4851 9.85059 29.4419 9.97379 29.4003 10.0794L28.5603 12.3786H30.7683ZM33.0483 14.9994H32.0499C31.9379 14.9994 31.8467 14.9722 31.7763 14.9178C31.7059 14.8602 31.6531 14.7898 31.6179 14.7066L31.0995 13.2906H28.2243L27.7059 14.7066C27.6803 14.7802 27.6307 14.8474 27.5571 14.9082C27.4835 14.969 27.3923 14.9994 27.2835 14.9994H26.2755L29.0067 8.05859H30.3219L33.0483 14.9994Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2221_645",
    x: 0,
    y: 0,
    width: 42.3999,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.901961 0 0 0 0 0.901961 0 0 0 0 0.901961 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2221_645"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2221_645",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/beta.51f31d9dca0083f13499d2e51beb95a6.svg";
export { ForwardRef as ReactComponent };